import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { NavLink, Link, withRouter } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import BusinessNavigation from 'components/Business-admin/BusinessNavigation';
import {
  ROUTES,
  insertIdtoUrl,
  insertBusinessIdtoUrl,
  ONBOARDING_ROUTES,
} from 'constants/Routes.js';
import {
  getRole,
  getBusinessId,
  clear,
  getConfirmed,
} from 'constants/localStorageManager.js';
import { USERS } from 'constants/Users.js';
import { NAVROUTES } from 'constants/NavRoutes';

import logo from 'assets/logo/soono_FF-02.png';
import 'assets/scss/header.css';
import 'assets/scss/header-design.css';
import 'assets/scss/menu.css';
import ButtonHOC from './hoc/buttonHOC';

function isSurveyTemplateActive(path) {
  return NAVROUTES.SURVEY_TEMPLATE.includes(path);
}

function isBusinessActive(path) {
  return NAVROUTES.BUSINESS.includes(path);
}

function isDashboardActive(path) {
  return NAVROUTES.DASHBOARD.includes(path);
}

const MainMenu = ({ match }) => {
  const { path } = match;

  return (
    <div className="nav-menu">
      <div className="top-header">
        <Nav>
          <NavItem className="header-nav-item">
            <NavLink
              to={ROUTES.DASHBOARD_INDEX}
              isActive={isDashboardActive.bind(this, path)}
              activeClassName="activeMenu"
            >
              <FontAwesomeIcon icon="tachometer-alt" />
              Dashboard
            </NavLink>
          </NavItem>
          <NavItem className="header-nav-item">
            <NavLink
              to={ROUTES.SURVEY_TEMPLATE_INDEX}
              isActive={isSurveyTemplateActive.bind(this, path)}
              activeClassName="activeMenu"
            >
              <FontAwesomeIcon icon="sitemap" />
              Survey Templates
            </NavLink>
            <span className="spanBorder" />
          </NavItem>
          <NavItem className="header-nav-item">
            <NavLink
              to={ROUTES.BUSINESS_INDEX}
              activeClassName="activeMenu active-menu"
              isActive={isBusinessActive.bind(this, path)}
            >
              <FontAwesomeIcon icon="briefcase" />
              Businesses
            </NavLink>
          </NavItem>
          <NavItem className="header-nav-item">
            <NavLink
              to={ROUTES.USER_INDEX}
              activeClassName="activeMenu active-menu"
            >
              <FontAwesomeIcon icon="sticky-note" />
              Users
            </NavLink>
          </NavItem>
          <NavItem className="header-nav-item d-sm-block d-md-block d-lg-none">
            <NavLink
              to={ROUTES.ADDONS_REQUEST}
              activeClassName="activeMenu active-menu"
            >
              Addon Requests
            </NavLink>
          </NavItem>
        </Nav>
      </div>
    </div>
  );
};

MainMenu.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string,
  }),
};

const WithRouteMainMenu = withRouter(MainMenu);

const RoleBasedHeader = ({ role }) => {
  if (role === USERS.ADMIN) return <WithRouteMainMenu />;
  return <BusinessNavigation />;
};

const RoleBasedMenu = ({ role, businessId }) => {
  if (role === USERS.BUSINESS_ADMIN) {
    return (
      <Fragment>
        <DropdownItem>
          <NavLink
            to={insertIdtoUrl(ROUTES.EDIT_BUSINESS_BASIC_INFO, businessId)}
          >
            Manage Account
          </NavLink>
        </DropdownItem>
        <DropdownItem>
          <NavLink to={insertIdtoUrl(ROUTES.USERS_LIST, businessId)}>
            Manage Users
          </NavLink>
        </DropdownItem>
        <DropdownItem>
          <NavLink
            to={insertBusinessIdtoUrl(ROUTES.BUSINESS_USER_DETAIL, businessId)}
          >
            Manage Profile
          </NavLink>
        </DropdownItem>
        <DropdownItem>
          <NavLink
            to={insertIdtoUrl(ROUTES.BUSINESS_BILLING_ACTIVITY, businessId)}
          >
            Billing Activity
          </NavLink>
        </DropdownItem>
        <DropdownItem>
          <NavLink to="/" onClick={() => clear()}>
            Sign out
          </NavLink>
        </DropdownItem>
      </Fragment>
    );
  }

  if (role === USERS.ADMIN) {
    return (
      <Fragment>
        <DropdownItem disabled className="dropdown-item text-muted cursor-none">
          Developer Tools
        </DropdownItem>
        <NavLink
          to={ROUTES.ADDONS_REQUEST}
          className="dropdown-item pl-4 cursor-pointer text-muted"
        >
          Addons Requests
        </NavLink>
        <DropdownItem divider />
        <NavLink
          to="/"
          className="dropdown-item pl-4 cursor-pointer text-muted"
          onClick={() => clear()}
        >
          Sign out
        </NavLink>
      </Fragment>
    );
  }

  return null;
};

const SupportLinks = () => (
  <Fragment>
    <Link
      className="dropdown-item"
      to="//resources.mysoono.com"
      target="_blank"
    >
      Resources
    </Link>
    <Link
      className="dropdown-item"
      to="//resources.mysoono.com/best-practices/"
      target="_blank"
    >
      Best Practices
    </Link>
    <Link
      className="dropdown-item"
      to="//resources.mysoono.com/getting-started/"
      target="_blank"
    >
      Getting Started
    </Link>
    {getRole() !== USERS.ADMIN && (
      <ButtonHOC>
        <Link className="dropdown-item" to={ONBOARDING_ROUTES.STEP_ONE}>
          Guided Tour
        </Link>
      </ButtonHOC>
    )}
    <DropdownItem divider />
    <Link
      className="dropdown-item"
      to="//lp.constantcontact.com/su/AS68ug5"
      target="_blank"
    >
      What's New?
    </Link>
    <Link
      className="dropdown-item"
      to="//survey.mysoono.com/survey/w9eE9mdC"
      target="_blank"
    >
      Send feedback
    </Link>
  </Fragment>
);

const SupportDropdown = ({ className, isSupportOpen }) => (
  <UncontrolledDropdown className={className}>
    <DropdownToggle
      nav
      className={`text-white resources-menu ${isSupportOpen &&
        'resources-menu-active'}`}
    >
      <FontAwesomeIcon icon="question-circle" />
    </DropdownToggle>
    <DropdownMenu className="nav-dropdown-menu resource-mobile-menu" right>
      <SupportLinks />
    </DropdownMenu>
  </UncontrolledDropdown>
);

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      isSupportOpen: false,
    };
  }

  toggle = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
    }));
  };

  toggleSupport = () => {
    this.setState(prevState => ({
      isSupportOpen: !prevState.isSupportOpen,
    }));
  };

  render() {
    const { isOpen, isSupportOpen } = this.state;
    const role = getRole();
    const businessId = getBusinessId();

    return (
      <div className="header-container">
        <Navbar color="faded" light expand="lg" className="top-header">
          <NavbarBrand href="/">
            <img src={logo} className="logo" />
          </NavbarBrand>
          <Collapse
            className={`width ${!getConfirmed() ? 'b-active' : 'b-deactive'}`}
            isOpen={isOpen}
            navbar
          >
            <RoleBasedHeader role={role} />
            <Nav className="ml-auto m-nav" navbar>
              <SupportDropdown className="d-none d-sm-none d-md-none d-lg-block" />
              <UncontrolledDropdown
                nav
                inNavbar
                className="d-none d-sm-none d-md-none d-lg-block"
              >
                <DropdownToggle nav caret className="text-white">
                  <FontAwesomeIcon icon="user-shield" />
                </DropdownToggle>
                <DropdownMenu className="nav-dropdown-menu" right>
                  <RoleBasedMenu role={role} businessId={businessId} />
                </DropdownMenu>
              </UncontrolledDropdown>
              <div
                className="dropdown-item d-sm-block d-md-block d-lg-none m-logout-btn"
                to="/"
                onClick={() => clear()}
              >
                Sign out
              </div>
            </Nav>
          </Collapse>
          <div className="d-flex d-lg-none flex-row">
            <SupportDropdown isSupportOpen={isSupportOpen} />
            <NavbarToggler onClick={this.toggle} />
          </div>
        </Navbar>
      </div>
    );
  }
}

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js